import { useEffect } from 'react'
import type { ReactNode } from 'react'

export function Drawer({
  open,
  title,
  onClose,
  children,
}: {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
}) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null
  return (
    <div
      className="fixed inset-0 z-40 bg-black/60"
      onClick={onClose}
      role="presentation"
    >
      <aside
        role="dialog"
        aria-label={title}
        className="panel absolute right-0 top-0 h-full w-full max-w-md overflow-y-auto border-l border-lime-strong bg-crt-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="sticky top-0 flex items-center justify-between border-b border-lime-soft bg-crt-panel px-4 py-2">
          <h2 className="text-xs uppercase tracking-widest text-crt-lime">
            {title}
          </h2>
          <button
            type="button"
            className="text-crt-dim hover:text-crt-lime"
            onClick={onClose}
            aria-label="close"
          >
            [x]
          </button>
        </header>
        <div className="p-4">{children}</div>
      </aside>
    </div>
  )
}
